import React, { useState } from "react";

const HomeworkCompletionCalculator = () => {
  const [days, setDays] = useState("");
  const [deadline, setDeadline] = useState(null);

  const calculateDeadline = () => {
    let today = new Date();
    today.setDate(today.getDate() + parseInt(days));
    setDeadline(today.toDateString());
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Homewrok Completion Calculator</h2>
      <input type="number" placeholder="Days Until Deadline" className="border p-2 w-full mt-3" onChange={(e) => setDays(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateDeadline}>Calculate Deadline</button>
      {deadline && <div className="mt-3 text-center text-lg">Due Date: <span className="font-bold text-green-600">{deadline}</span></div>}
    </div>
  );
};

export default HomeworkCompletionCalculator;
